import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

interface UseLogClickShareFolderParams {
  folderSno: number;
  folderName: string | null | undefined;
  goodsCount: number | null | undefined;
  likesCount: number | null | undefined;
  hasCoverImage: boolean;
}

export const useLogClickShareFolder = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(
    ({
      folderSno,
      folderName,
      goodsCount,
      likesCount,
      hasCoverImage,
    }: UseLogClickShareFolderParams) => {
      logAnalyticsEvent({
        name: 'CLICK_SHARE_FOLDER',
        analytics: {
          FOLDER_SNO: folderSno.toString(),
          FOLDER_NAME: folderName ?? '',
          GOODS_COUNT: goodsCount ?? 0,
          LIKES_COUNT: likesCount ?? 0,
          IS_COVER_IMAGE_EXIST: hasCoverImage ? '1' : '0',
        },
      });
    },
    [logAnalyticsEvent],
  );
};
